import { render, staticRenderFns } from "./CustomerBaseData.vue?vue&type=template&id=5bf8bef6"
import script from "./CustomerBaseData.vue?vue&type=script&lang=js"
export * from "./CustomerBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports